<template>
  <OffersList
    v-if="cptdRequestedOffersList.length || (cptdIsGroupB && cptdJuvoOffer)"
    title="Continuar solicitação"
  >
    <NoCollateralProposedOfferCardContainer
      v-if="cptdIsGroupB && cptdJuvoOffer"
      :key="cptdJuvoOffer.offer_id"
      v-bind="$attrs"
      :offer="cptdJuvoOffer"
      :custom-partner-tags="{
        JUVO: {
          label: 'Continuar contratação',
          type: UIFeedbackTypes['POSITIVE-LIGHT'],
        },
      }"
    />
    <RequestedOfferCardTemplateMethodContainer
      v-for="offer in cptdRequestedOffersList"
      :key="offer.offer_id"
      v-bind="$attrs"
      :offer="offer"
    />
  </OffersList>
</template>
<script>
import { mapGetters } from 'vuex'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import RequestedOfferCardTemplateMethodContainer from '@/containers/loans/RequestedOfferCardTemplateMethodContainer.vue'
import NoCollateralProposedOfferCardContainer from '@/containers/loans/no-collateral/offer/NoCollateralProposedOfferCardContainer.vue'
import { abTest } from '@/helpers/abTest'
import { Partner } from '@/data/common'
import { UIFeedbackTypes } from '~/helpers/offer-types'
export default {
  name: 'RequestedOffersListContainer',
  components: {
    OffersList,
    RequestedOfferCardTemplateMethodContainer,
    NoCollateralProposedOfferCardContainer,
  },
  computed: {
    UIFeedbackTypes() {
      return UIFeedbackTypes
    },
    ...mapGetters({
      gtAllOnGoingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllOnGoingAutoOffers',
      gtAllOnGoingNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllOnGoingNoCollateralOffers',
      gtAllOnGoingHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllOnGoingHomeEquityOffers',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
    }),
    cptdJuvoOffer() {
      return this.gtAllProposedNoCollateralOffers.find(
        (offer) => offer.partner === Partner.JUVO,
      )
    },
    cptdIsGroupB() {
      return abTest() === 'B'
    },
    cptdRequestedOffersList() {
      return [
        ...this.gtAllOnGoingNoCollateralOffers,
        ...this.gtAllOnGoingAutoOffers,
        ...this.gtAllOnGoingHomeEquityOffers,
      ]
    },
  },
}
</script>
<style lang="scss"></style>
